import * as React from "react";
import { SunglassesEcommProvider, EcommFacetProvider, SunglassesStickyCTA, SunglassesEcommContent, useProductDetailSlots, ProductDetailFullWidth, FrameMeasurements, ProductDetailStack, ProductDetailDescription, ProductDetailFeatures, BrandPromotion, ProductDetailDisclaimer, ProductDetailDrawerStack, ProductDetailSpecification, ProductDetailManufacturerDrawer, ProductDetailReviewsDrawer, ProductImageGallery, mapServerToSunglassesProduct, getSunglassesBySlug } from "@grandvisionhq/fun-products";
import { P as ProductPageLayoutBase, a as ProductPageBase, c as defaultProductWithAFrameFacetConfig, f as fetchProductConfigBySlug, h as handleValidations } from "../../ProductPageLayoutBase.js";
import { e as defaultSunglassesFlatFacetConfig } from "../../default-flat-facet-configs.js";
import { CmsComponentSlot } from "@grandvisionhq/bloomreach";
import { V as VirtualMirrorContainer } from "../../VirtualMirrorContainer.js";
const EcommContent = SunglassesEcommContent;
const ImageGallery = () => /* @__PURE__ */ React.createElement(
  ProductImageGallery,
  {
    slots: {
      TopLeft: VirtualMirrorContainer,
      TopRight: BrandPromotion
    }
  }
);
const PrimaryProductInfo = (props) => /* @__PURE__ */ React.createElement(ProductDetailStack, { ...props }, /* @__PURE__ */ React.createElement(ProductDetailDescription, { className: "product-detail-stack__description" }, /* @__PURE__ */ React.createElement(ProductDetailFeatures, null), /* @__PURE__ */ React.createElement(BrandPromotion, { isClickable: true, size: "large" })), /* @__PURE__ */ React.createElement(ProductDetailDisclaimer, { className: "product-detail-stack__disclaimer" }), /* @__PURE__ */ React.createElement(ProductDetailDrawerStack, { className: "product-detail-stack__drawer-stack" }, /* @__PURE__ */ React.createElement(ProductDetailSpecification, null), /* @__PURE__ */ React.createElement(ProductDetailManufacturerDrawer, null), /* @__PURE__ */ React.createElement(ProductDetailReviewsDrawer, null)));
const SecondaryProductInfo = () => {
  const { Slots: OpcoSlots } = useProductDetailSlots();
  return /* @__PURE__ */ React.createElement(ProductDetailFullWidth, null, /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "main/row-pdp-container" }), /* @__PURE__ */ React.createElement(FrameMeasurements, null), OpcoSlots.SecondaryProductInfoSlot && /* @__PURE__ */ React.createElement(OpcoSlots.SecondaryProductInfoSlot, null));
};
const SunglassesDetailPage = () => {
  return /* @__PURE__ */ React.createElement(SunglassesEcommProvider, null, /* @__PURE__ */ React.createElement(EcommFacetProvider, null, /* @__PURE__ */ React.createElement(
    ProductPageLayoutBase,
    {
      EcommContent,
      ImageGallery,
      PrimaryProductInfo,
      StickyCta: SunglassesStickyCTA,
      SecondaryProductInfo
    }
  )));
};
const Page = ({
  facetConfigList,
  ...props
}) => {
  return /* @__PURE__ */ React.createElement(
    ProductPageBase,
    {
      ...props,
      facetConfigList: facetConfigList ?? defaultProductWithAFrameFacetConfig
    },
    /* @__PURE__ */ React.createElement(SunglassesDetailPage, null)
  );
};
Page.getInitialProps = async (ctx) => {
  const productConfig = await fetchProductConfigBySlug(
    ctx,
    getSunglassesBySlug,
    mapServerToSunglassesProduct,
    ctx.pageConfig?.facetConfigList ?? defaultProductWithAFrameFacetConfig,
    ctx.pageConfig?.flatFacetConfigList ?? defaultSunglassesFlatFacetConfig
  );
  if ("failure" in productConfig) {
    return handleValidations(productConfig, `Error while initializing Sunglasses PDP`);
  }
  const { product, activeVariant, sku, slug, bloomreachPathOverride } = productConfig;
  return {
    sku,
    slug,
    product,
    activeVariant,
    bloomreachPathOverride
  };
};
export {
  Page
};
//# sourceMappingURL=sunglasses.js.map
